import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Grid
} from '@mui/material';
import { formatMoney } from '../../../../../../../../lib/functions/utils';
import CustomButton from '../../../../../../../../lib/designSystem/Button';

interface GroupedLine {
  account: string;
  accountName: string;
  description: string;
  documentId: string;
  debit: number;
  credit: number;
}

interface Category {
  businessIdentifier: string;
  businessName: string;
  category: string;
  groupedLines: GroupedLine[];
  date: string;
}

interface CategoryModalProps {
  category?: Category;
  open: boolean;
  onClose: () => void;
}

const CategoryModal: React.FC<CategoryModalProps> = ({ category, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} md={8}>
            <Typography 
              variant="h5" 
              component="div" 
              sx={{ 
                fontWeight: 600, 
                color: '#2c3e50',
                mb: 1
              }}
            >
              {category?.category}
            </Typography>
            <Typography 
              variant="body1" 
              component="div"
              sx={{ 
                color: '#7f8c8d',
                fontWeight: 500
              }}
            >
              {category?.businessName}
            </Typography>
            <Typography 
              variant="body2" 
              component="div"
              sx={{ 
                color: '#95a5a6',
                fontStyle: 'italic'
              }}
            >
              RUT: {category?.businessIdentifier}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              component="div"
              sx={{ 
                textAlign: { xs: 'left', md: 'right' },
                color: '#2c3e50',
                fontWeight: 500
              }}
            >
              {category?.date}
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Cuenta</TableCell>
              <TableCell>Nombre de Cuenta</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Documento</TableCell>
              <TableCell>Debe</TableCell>
              <TableCell>Haber</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(category?.groupedLines ?? []).map((line, lineIndex) => (
              <TableRow key={lineIndex}>
                <TableCell>{line.account}</TableCell>
                <TableCell>{line.accountName}</TableCell>
                <TableCell>{line.description}</TableCell>
                <TableCell>{line.documentId}</TableCell>
                <TableCell>{formatMoney(line.debit)}</TableCell>
                <TableCell>{formatMoney(line.credit)}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell
                colSpan={4}
                style={{
                  fontWeight: 'bold',
                  textAlign: 'left',
                }}
              >
                Totales:
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold' }}
              >
                {formatMoney(
                  (category?.groupedLines ?? []).reduce(
                    (sum, line) => sum + line.debit,
                    0,
                  ),
                )}
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold' }}
              >
                {formatMoney(
                  (category?.groupedLines ?? []).reduce(
                    (sum, line) => sum + line.credit,
                    0,
                  ),
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary">
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryModal;